import { Card } from "primereact/card";
import { Button } from "primereact/button"; // Import PrimeReact Button
import React, { useDebugValue, useEffect, useState } from "react";
import { Text } from "../../components/Text";
import { Divider } from "primereact/divider";
import { CustomButton } from "../../components/CustomButton";
import QuickNotes from "./QuickNotes";
import { Dialog } from "primereact/dialog";
import OfficeHours from "./OfficeHours";
import { getOfficeTimes } from "../../reducers/officetimeSlice";
import { useDispatch, useSelector } from "react-redux";

const OfficeTime = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const dispatch = useDispatch();
  const officeTime = useSelector(
    (state) => state?.officeTime?.officeTimes?.data
  );
  // console.log("officeTime", officeTime);
  const onHile = () => {
    setModalVisible(false);
  };
  useEffect(() => {
    dispatch(getOfficeTimes());
  }, [dispatch, isModalVisible]);
  const dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes}`;
  };
  return (
    <div className="w-full p-3  " style={{ background: "#ffffff" }}>
      <div className="col-4">
        <Card
          title={
            <div
              className="flex justify-between items-center"
              style={{ justifyContent: "space-between" }}
            >
              <div className="mb-3 ">
                <Text type={"heading"}>Current Office Hours:</Text>
              </div>
              <div>
                <CustomButton
                  label={"Edit"}
                  icon={"pi pi-pencil"}
                  onClick={() => setModalVisible(true)}
                  varient={"outline"}
                />
              </div>
            </div>
          }
          className="p-2 text-bold"
          style={{ background: "#F9F9F9" }}
        >
          {officeTime &&
            [...officeTime]
              .sort((a, b) => a.day - b.day)
              .map((item) => (
                <div className="flex items-center justify-between mb-2">
                  <div className="w-60">
                    <Text type="heading" className="font-medium text-gray-800">
                      {dayNames[item.day]}:
                    </Text>
                  </div>

                  <div className="flex gap-2 text-sm text-gray-700">
                    <Text type="sub-heading">
                      {formatTime(item.startTime)} -
                    </Text>
                    <Text type="sub-heading">{formatTime(item.endTime)}</Text>
                  </div>
                </div>
              ))}
        </Card>
      </div>
      <Divider />
      <div>
        <div className="mb-3">
          <Text type={"heading"}>Off-hours Quick Notes</Text>
        </div>
        <div className="p-3">
          <QuickNotes />
        </div>
      </div>
      {isModalVisible && (
        <Dialog
          visible={isModalVisible}
          onHide={() => setModalVisible(false)}
          style={{ width: "45vw" }}
          draggable={false}
          closable={false}
        >
          <OfficeHours onHile={onHile} officeTime={officeTime} />
        </Dialog>
      )}
    </div>
  );
};

export default OfficeTime;
